// Imports
import Vue from 'vue'
import Router from 'vue-router'
import { trailingSlash } from '@/util/helpers'
import {
  layout,
  route,
  checkPermission
} from '@/util/routes'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import RegisterStep from '../views/RegisterStep.vue'
import Logout from '../views/Logout.vue'
import ZarinPalCallback from '../views/ZarinPalCallback.vue'
import ZarinPalMemberCallback from '../views/ZarinPalMemberCallback.vue'
import ZibalCallback from '../views/ZibalCallback.vue'
import ZibalMemberCallback from '../views/ZibalMemberCallback.vue'
import SepMemberCallback from '../views/SepMemberCallback.vue'
import SadadMemberCallback from '../views/SadadMemberCallback.vue'
import IPGMemberCallback from '../views/IPGMemberCallback.vue'
import SepehrMemberCallback from '../views/SepehrMemberCallback.vue'
import NextPayMemberCallback from '../views/NextPayMemberCallback.vue'
import PreOnlinePayment from '../views/PreOnlinePayment.vue'
import WalletCharge from '../views/WalletCharge.vue'
import PreAgentFactorPayment from '../views/PreAgentFactorPayment.vue'
import PreDigitalSignContract from '../views/PreDigitalSignContract.vue'
import PreThirdPersonDigitalSignContract from '../views/PreThirdPersonDigitalSignContract.vue'
import Store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      name: 'Login',
      path: '/login/:customerCode?',
      component: Login,
    },
    {
      name: 'Register',
      path: '/register/:customerCode?',
      component: RegisterStep,
    },
    {
      name: 'Logout',
      path: '/logout',
      component: Logout,
    },
    {
      name: 'GatewayCallback',
      path: '/gateway/zarinPalCallback',
      component: ZarinPalCallback,
    },
    {
      name: 'GatewayMemberCallback',
      path: '/gateway/zarinPalMemberCallback',
      component: ZarinPalMemberCallback,
    },
    {
      name: 'ZibalCallback',
      path: '/gateway/zibalCallback',
      component: ZibalCallback,
    },
    {
      name: 'ZibalMemberCallback',
      path: '/gateway/zibalMemberCallback',
      component: ZibalMemberCallback,
    },
    {
      name: 'GatewaySepMemberCallback',
      path: '/gateway/sepMemberCallback',
      component: SepMemberCallback,
    },
    {
      name: 'GatewaySadadMemberCallback',
      path: '/gateway/sadadMemberCallback',
      component: SadadMemberCallback,
    },
    {
      name: 'GatewayIPGMemberCallback',
      path: '/gateway/ipgMemberCallback',
      component: IPGMemberCallback,
    },
    {
      name: 'GatewaySepehrMemberCallback',
      path: '/gateway/sepehrMemberCallback',
      component: SepehrMemberCallback,
    },
    {
      name: 'GatewayNextPayMemberCallback',
      path: '/gateway/nextPayMemberCallback',
      component: NextPayMemberCallback,
    },
    {
      name: 'PreOnlinePayment',
      path: '/pop/:customerCode/:loanPaymentCode',
      component: PreOnlinePayment,
    },
    {
      name: 'WalletCharge',
      path: '/walletcharge/:ucode?',
      component: WalletCharge,
    },
    {
      name: 'PreAgentFactorPayment',
      path: '/afpp/:customerCode?/:agentFactorCode?',
      component: PreAgentFactorPayment,
    },
    {
      name: 'PreDigitalSignContract',
      path: '/dgs/:ccode/:acode',
      component: PreDigitalSignContract,
    },
    {
      name: 'PreThirdPersonDigitalSignContract',
      path: '/tpdgs/:ccode/:acode',
      component: PreThirdPersonDigitalSignContract,
    },
    {
      name: 'PreOnlinePayment2',
      path: '/pop',
      component: PreOnlinePayment,
    },
    layout('Default', [
      route('admin/Dashboard', null, 'dashboard'),

      // Pages
      route('admin/Users', null, 'users'),

      // Components
      route('admin/Members', null, 'members', { claim: 'Members' }),
      route('admin/agent/Agents', null, 'agents', { claim: 'Agents' }),
      route('admin/sponsor/Sponsors', null, 'sponsors', { claim: 'Sponsors' }),
      route('admin/contact/Contacts', null, 'contacts', { claim: 'Contacts' }),
      route('admin/marketer/Marketers', null, 'marketers', { claim: 'Marketers' }),

      route('admin/ImportFile/SavedMoneyImport', null, 'savedMoneyimport'),
      route('admin/ImportFile/InstallmentImport', null, 'installmentsimport'),
      route('admin/ImportFile/RemainComparer', null, 'remainComparer'),
      route('admin/Loans', null, 'loans', { claim: 'Loans' }),
      route('admin/UserLoanPaymentRequests', null, 'loanPaymentRequests', { claim: 'PaymentRequests' }),
      route('admin/UserLoanRequests', null, 'userLoanRequests/:statusFilter?', { claim: 'LoanRequests' }),
      route('admin/MemberAuthorizations', null, 'memberAuthorizations/:statusFilter?'),
      route('admin/SMSListContainer', null, 'smslist', { claim: 'Sms' }),
      route('admin/InquiryManagement', null, 'inquirymanagement', { claim: 'Inquiry' }),
      route('admin/Report/Reports', null, 'reports', { claim: 'Reports' }),
      route('admin/Report/CheckoutThisMonth', null, 'checkoutThisMonth'),
      route('admin/Report/CheckoutedMembers', null, 'checkouted-members'),
      route('admin/Report/LatestMembers', null, 'latestMembers'),
      route('admin/Report/RemainInstallmentCount', null, 'remainInstallmentCount'),
      route('admin/Report/Members', null, 'report-members'),
      route('admin/Report/InstallmentsByMonth', null, 'report-installments-month'),
      route('admin/Report/PaidInstallmentsByMonth', null, 'report-paid-installments-month'),
      route('admin/Report/SaveMoniesByMonth', null, 'report-saveMonies-month'),
      route('admin/Report/MemberLoans', null, 'report-member-loans'),
      route('admin/Report/MonthlyBalance', null, 'report-monthly-balance'),
      route('admin/Report/SponsoredLoans', null, 'sponsored-loans'),
      route('admin/Report/OnlineGatewayPayments', null, 'wallet-transactions'),
      route('admin/Report/IranValidityReport', null, 'iran-validity-reports'),
      route('admin/IranValidity', null, 'iran-validity'),
      route('admin/Report/OrganizationDueDated', null, 'organization-duedated-reports'),
      route('admin/Report/Assurances', null, 'assurances-report'),
      route('admin/Report/AgentFactors', null, 'agentFactors'),
      route('admin/Report/LoanStatistics', null, 'loanStatistics'),
      route('admin/Report/DigitalSignContracts', null, 'digitalSignContracts'),
      route('admin/Expense', null, 'expense'),
      route('admin/Buy', null, 'buy'),
      route('admin/PurchasedPlans', null, 'purchasedPlans'),
      route('admin/MemberProfile', null, 'memberProfile/:memberId'),
      route('admin/Tickets', null, 'tickets/:statusFilter?', { claim: 'Tickets' }),
      route('admin/CustomerOrders', null, 'customerOrders/:statusFilter?', { claim: 'CustomerOrders' }),

      // Otherwise
      // {
      //   path: '/admin/*',
      //   redirect: 'admin/Dashboard',
      // },
    ], '/admin'),
    layout('Member', [
      route('member/Dashboard', null, 'dashboard'),
      route('member/Loans', null, 'loans'),
      route('member/SavedMoney', null, 'savedmoney'),
      route('member/UserLoanRequests', null, 'loanRequest/:id?'),
      route('member/UserLoanPaymentRequests', null, 'loanPaymentRequests'),
      route('member/IceReports', null, 'iceReports'),
      route('member/IranValidityReports', null, 'iranValidityReports'),
      route('member/Tickets', null, 'tickets'),
      route('member/AgentFactors', null, 'agentFactors'),
      route('member/Authorization', null, 'authorization'),

      // Otherwise
      // {
      //   path: '/member/*',
      //   redirect: 'member/Dashboard',
      // },
    ], '/member'),
    layout('SuperAdmin', [
      route('superAdmin/Dashboard', null, 'dashboard'),
      route('superAdmin/Marketers', null, 'marketers'),
      route('superAdmin/Customers', null, 'customers'),
      route('superAdmin/SmsPatterns', null, 'smsPatterns'),
      route('superAdmin/Consultants', null, 'consultants'),
      route('superAdmin/Purchases', null, 'purchases'),
      route('superAdmin/InquiryManagement', null, 'inquirymanagement'),
      route('superAdmin/SmsManagement', null, 'smsmanagement'),
      // Otherwise
      // {
      //   path: '/member/*',
      //   redirect: 'member/Dashboard',
      // },
    ], '/superadmin'),
    layout('Agent', [
      route('agent/Dashboard', null, 'dashboard'),
      route('agent/Customers', null, 'customers'),
      route('agent/UserLoanRequests', null, 'loanRequests'),
      route('agent/SponsorePayments', null, 'sponsorePayments'),
      route('agent/sub-agent/Agents', null, 'agents'),
      route('agent/SubAgentTransactions', null, 'subAgentTransactions'),
      route('agent/AccountWarning', null, 'accountWarning/:status?'),
      route('agent/Tickets', null, 'tickets'),
      route('agent/AgentFactors', null, 'agentFactors'),
      // Otherwise
      // {
      //   path: '/member/*',
      //   redirect: 'member/Dashboard',
      // },
    ], '/agent'),
    layout('Sponsor', [
      route('sponsor/Dashboard', null, 'dashboard'),
      // Otherwise
      // {
      //   path: '/member/*',
      //   redirect: 'member/Dashboard',
      // },
    ], '/sponsor'),
    layout('CustomerMarketer', [
      route('customerMarketer/Dashboard', null, 'dashboard'),
      // Otherwise
      // {
      //   path: '/member/*',
      //   redirect: 'member/Dashboard',
      // },
    ], '/customermarketer'),
    layout('Landing', [
      route('landing/Home', null, '/'),
      route('landing/JetLanding', null, 'jetlanding'),
      route('landing/CreditInquiryLanding', null, 'credit-inquiry'),
      route('landing/SmartSmsLanding', null, 'smart-sms'),
      route('landing/OnlinePaymentLanding', null, 'online-payment'),
      route('landing/LoanFormulasLanding', null, 'loan-formulas'),
      route('landing/FinancialReportsLanding', null, 'financial-reports'),
      route('landing/CustomerPortalLanding', null, 'customer-portal'),
      // Otherwise
      // {
      //   path: '/member/*',
      //   redirect: 'member/Dashboard',
      // },
    ], '/'),
    layout('CustomerLanding', [
      route('customerLanding/Home', null, '/'),
      route('customerLanding/Plans', null, 'plans/:customerCode?'),
      route('customerLanding/Plan', null, 'plan/:customerCode/:code/:title?'),
      route('customerLanding/OurPlans', null, 'ourplans/:customerCode?'),
      route('customerLanding/AgentRegister', null, 'agentregister/:customerCode?'),
      // Otherwise
      // {
      //   path: '/member/*',
      //   redirect: 'member/Dashboard',
      // },
    ], '/cl'),
  ],
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/', '/login', '/login/', '/logout', '/logout/', '/admin/buy', '/admin/buy/', '/admin/purchasedPlans', '/admin/purchasedPlans/', '/jetlanding', '/jetlanding/', '/credit-inquiry', '/credit-inquiry/']
  const loggedInUser = (Store.state.auth || {}).user
  const expireDate = loggedInUser?.userData?.customer?.expireDate || '0001-01-01T00:00:00'
  const agentStatusAccount = loggedInUser?.userData?.metaData?.status || 0

  if (publicPages.includes(to.path)) {
    return to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
  }
  let publicPages2 = [
    'jetlanding',
    'credit-inquiry',
    'zarinPalCallback',
    'zarinPalMemberCallback',
    'sepMemberCallback',
    'ipgMemberCallback',
    'nextPayMemberCallback',
    'sadadMemberCallback',
    'pop',
    'plan',
    'register',
    'login',
    'agentregister',
    'walletcharge',
    'dgs',
    'afpp',
    'customer-portal',
    'financial-reports',
    'loan-formulas',
    'online-payment',
    'smart-sms'
  ]
  if (publicPages2.some(x => to.path.indexOf(x) > -1))
    return to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
  const adminAuthRequired = to.path.startsWith('/admin')
  if (adminAuthRequired && (!loggedInUser || new Date(expireDate).getFullYear() < 1000 || !(loggedInUser.userData.userRoleNames || []).includes('Admin'))) {
    if (from.path.indexOf('login') === -1) {
      return next('/login')
    }
  }

  const memberAuthRequired = to.path.startsWith('/member')
  if (memberAuthRequired && (!loggedInUser || new Date(expireDate).getFullYear() < 1000 || !(loggedInUser.userData.userRoleNames || []).includes('Member'))) {
    if (from.path.indexOf('login') === -1)
      return next('/login')
  }

  if (to.path.toLowerCase().startsWith('/agent') && !to.path.toLowerCase().includes('/accountwarning') && agentStatusAccount != 1) {
    return next(`/agent/accountWarning/${agentStatusAccount}`)
  }

  if (new Date(expireDate) <= new Date() && !to.path.toLowerCase().startsWith('/superadmin')) {
    return next(`${adminAuthRequired ? '/admin' : '/member'}/buy`)
  }

  if (to.meta?.claim && !checkPermission(to.meta?.claim) && to.path.startsWith('/admin'))
    return next('/admin/dashboard')

  return to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
})

export default router
